// A route intersection node (clickable/draggable)
class RouteNode {
  constructor(idx, lngLat) {
    this.id = idx;
    this.idx = idx;
    this.lngLat = lngLat;
  }
}

export { RouteNode };
